import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { Dialog } from '../../../../components';
import Text from '../../../../components/Text';
import { ORDER_SERVICE_STATUS_ENUM } from '../../../../comm/constant';

const ServiceHistoryPopup = ({ handleClose, data }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      title="Service History"
      cancel="Cancel"
      confirm="Confirm"
      dialogfootStyle={{ marginTop: '2.5rem' }}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleClose}
      readOnly
    >
      <Box display="grid" gridTemplateColumns="1fr 1fr" gridGap="1.25rem" mb="1.87rem">
        <SummaryTile title="Service" value={data?.serviceDesc} />
        <SummaryTile title="Order By" value={data?.orderBy} />
        <SummaryTile title="Order Time" value={moment(data?.orderDate).format('YYYY-MM-DD HH:mm')} />
        <SummaryTile title="Remark" value={data?.serviceRemark} />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gridGap="1.25rem"
        borderRadius="0.9375rem"
        bgcolor="#F5FAFF"
        p="1.25rem 1.88rem"
      >
        <Box display="flex" gridGap="1.25rem" width="100%">
          <Text
            fontSize="1rem"
            color="#538fff"
            fontWeight="700"
            style={{ flexBasis: '50%', textTransform: 'uppercase' }}
          >
            Service Status
          </Text>
          <Text
            fontSize="1rem"
            color="#538fff"
            fontWeight="700"
            style={{ flexBasis: '50%', textTransform: 'uppercase' }}
          >
            Update Time
          </Text>
        </Box>
        {data?.orderDate && (
          <Box display="flex" gridGap="1.25rem" width="100%">
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              <Box className={classes.circle} bgcolor="#FFC95C" /> {ORDER_SERVICE_STATUS_ENUM?.W?.text}
            </Text>
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              {moment(data?.orderDate).format('YYYY-MM-DD HH:mm')}
            </Text>
          </Box>
        )}
        {data?.arrivalDate && (
          <Box display="flex" gridGap="1.25rem" width="100%">
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              <Box className={classes.circle} bgcolor="#FFC95C" /> {ORDER_SERVICE_STATUS_ENUM?.R?.text}
            </Text>
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              {moment(data?.arrivalDate).format('YYYY-MM-DD HH:mm')}
            </Text>
          </Box>
        )}
        {data?.completedDate && (
          <Box display="flex" gridGap="1.25rem" width="100%">
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              <Box className={classes.circle} bgcolor="#FFC95C" /> {ORDER_SERVICE_STATUS_ENUM?.C?.text}
            </Text>
            <Text fontSize="1rem" color="#2E4469" style={{ flexBasis: '50%' }}>
              {moment(data?.completedDate).format('YYYY-MM-DD HH:mm')}
            </Text>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

const SummaryTile = ({ title, value }) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="0.62rem">
      <Text fontSize="1rem" color="#2E4469">
        {title}
      </Text>
      <Text fontSize="1rem" color="#7D86A9">
        {value}
      </Text>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  circle: {
    width: '0.625rem',
    height: '0.625rem',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '0.25rem',
  },
}));

export default ServiceHistoryPopup;
